import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/content';
import { trackCheckoutIntent } from '../utils/analytics';
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 560);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-216" data-mp="3vebro037qpuh">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.45,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-sand bg-ivory/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-217" data-mp="3vdahdxu0u7dt">
          <div className="flex items-center gap-4" data-id="element-218" data-mp="1w3c4xeeles4n">
            <div className="shrink-0" data-id="element-219" data-mp="29fivm4r3g6ig">
              <p className="font-display text-xl font-light leading-none text-ink" data-id="element-220" data-mp="29cmuk7jy91ps">{PRICE}</p>
              <p className="mt-1 flex items-center gap-1 font-sans text-[0.56rem] uppercase tracking-[0.14em] text-mute" data-id="element-221" data-mp="2ee2f7yi7t67n">
                <LockIcon className="h-2.5 w-2.5 text-gold" aria-hidden="true" data-id="element-222" data-mp="2idl3n498vzf8" />
                Pago seguro
              </p>
            </div>
            <a href={CHECKOUT_URL} onClick={() => trackCheckoutIntent('sticky-movil')} className="flex-1 rounded-full bg-ink px-5 py-3.5 text-center font-sans text-[0.66rem] uppercase tracking-luxe text-ivory transition-colors duration-500 hover:bg-gold" data-id="element-223" data-mp="2s45xkedz4frt">
              Quiero volver a mí
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}